import { IControllerConstructor } from 'angular';
import { UsageRatingRulesController } from './usage-rating-rules.controller';
import * as UsageRatingRuleRoutes from './usage-rating-rules.routes';

/**
 * The entry point the unrated journeys module
 */
export const initialise = () => {

  angular.module('app.usage-rating-rules', [
    'pascalprecht.translate',
    'actora.services',
    'app.layout',
    'app.components',
    
  ])
  .controller('UsageRatingRulesController', <IControllerConstructor>UsageRatingRulesController);

  UsageRatingRuleRoutes.initialise();
}